"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.correctResultSchema = exports.recordResultSchema = exports.RECORDED_RESULT_FIELD = exports.SCORESHEET_FIELD = exports.RECORDED_SCORE_MAX = exports.RECORDED_PLATFORM_MAX = exports.RECORDED_TEST_NAME_MAX = exports.RECORDED_HOW_LABELS = exports.RECORDED_HOWS = void 0;
exports.isRecordedHow = isRecordedHow;
exports.recordedSourceLabel = recordedSourceLabel;
exports.mayRecordResult = mayRecordResult;
const zod_1 = require("zod");
// F9.18 — a test result typed in by hand (ADR 0047, DECISIONS-LOG 2026-10-16 Q2): a test sat
// on paper in the office, or taken on another site. Recorded on ⑦ Assessment's results, it
// is judged by the job's pass mark and suggests the next step like any other result.
exports.RECORDED_HOWS = ['paper', 'elsewhere'];
exports.RECORDED_HOW_LABELS = {
    paper: 'On paper, in the office',
    elsewhere: 'Online, on another site',
};
exports.RECORDED_TEST_NAME_MAX = 120;
exports.RECORDED_PLATFORM_MAX = 120;
/** A score is whole or half marks, up to this. */
exports.RECORDED_SCORE_MAX = 10_000;
/** The scoresheet travels with the result as one file (the `documents` 10 MB cap). */
exports.SCORESHEET_FIELD = 'scoresheet';
exports.RECORDED_RESULT_FIELD = 'result';
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
exports.recordResultSchema = zod_1.z
    .object({
    testName: zod_1.z.string().trim().min(1, 'This field is required.').max(exports.RECORDED_TEST_NAME_MAX),
    how: zod_1.z.enum(exports.RECORDED_HOWS),
    /** "HackerRank", "Google Forms"…; only for a test taken elsewhere. */
    platform: zod_1.z.string().trim().max(exports.RECORDED_PLATFORM_MAX).nullable(),
    score: zod_1.z.number().min(0, 'The score cannot be below 0.').max(exports.RECORDED_SCORE_MAX),
    outOf: zod_1.z.number().positive('Out of must be more than 0.').max(exports.RECORDED_SCORE_MAX),
    /** The day it was taken, as the recruiter's calendar shows it. */
    takenOn: zod_1.z.string().regex(DATE_ONLY, 'Choose the date it was taken.'),
    /** The application's row version (S7): a stale screen gets 409, not a silent overwrite. */
    version: zod_1.z.number().int().min(1),
})
    .superRefine((input, context) => {
    if (input.score > input.outOf)
        context.addIssue({ code: 'custom', path: ['score'], message: 'The score cannot be more than the total.' });
});
function isRecordedHow(value) {
    return exports.RECORDED_HOWS.some((how) => how === value);
}
/** Where a recorded result came from, in one phrase: "HackerRank" or "On paper, in the office". */
function recordedSourceLabel(recorded) {
    if (recorded.how === 'elsewhere' && recorded.platform)
        return recorded.platform;
    return exports.RECORDED_HOW_LABELS[recorded.how];
}
const OPEN = ['not_started', 'in_progress'];
/**
 * Whether ⑦ offers "Record a result" for one person: in Assessment, no link or seat still
 * open, not already passed, and an attempt left. A recorded result uses one up (ADR 0019).
 */
function mayRecordResult(input) {
    if (input.stage !== 'assessment')
        return false;
    if (input.latestStatus !== null && OPEN.includes(input.latestStatus))
        return false;
    if (input.latestDidPass === true)
        return false;
    return input.attemptsUsed < input.attemptsAllowed;
}
/** A recorded result can be corrected while the person is still in Assessment. */
exports.correctResultSchema = zod_1.z
    .object({
    score: zod_1.z.number().min(0, 'The score cannot be below 0.').max(exports.RECORDED_SCORE_MAX),
    outOf: zod_1.z.number().positive('Out of must be more than 0.').max(exports.RECORDED_SCORE_MAX),
    version: zod_1.z.number().int().min(1),
})
    .superRefine((input, context) => {
    if (input.score > input.outOf)
        context.addIssue({ code: 'custom', path: ['score'], message: 'The score cannot be more than the total.' });
});
//# sourceMappingURL=recorded-results.js.map